import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, inject, Input, ViewChild } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { DividerModule } from 'primeng/divider';
import { compareDate, getFirstAndLastInitial, getFontSize, getRemainingDaysByDate } from '../../../utils/common.util';
import {
  DashboardService,
  ProjectLeadRequest,
} from '../../../services/dashboard.service';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { debounceTime, Subject, switchMap } from 'rxjs';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AutoScrollDirective } from '../../../directives/auto-scroll.directive';

@Component({
  selector: 'emc-section-item',
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    CardModule,
    ChartModule,
    DividerModule,
    RadioButtonModule,
    AutoScrollDirective,
  ],
  templateUrl: './section-item.component.html',
  styleUrl: './section-item.component.scss',
})
export class SectionItemComponent {
  @Input() project!: any;
  chartData: any;
  options: any;
  progressData: any;
  tasks: any;
  dashboardService: DashboardService = inject(DashboardService);
  projectLead: ProjectLeadRequest = {
    projectId: '',
    projectLeadName: 'Project Lead Name',
    projectLeadTitle: 'Title',
  };
  isEditLead: boolean = false;
  isEditTitle: boolean = false;
  remainingDay: number = 0;

  scaleText = 150 * getFontSize(window.innerWidth, window.devicePixelRatio) / 100

  lead$ = new Subject<ProjectLeadRequest>();

  @ViewChild('wrapper', { static: true }) wrapper!: ElementRef;
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.wrapper.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.isEditLead = false;
      this.isEditTitle = false;
    }
  }

  ngOnInit() {
    this.lead$
    .pipe(
      debounceTime(500),
      switchMap(() =>
        this.updateProjectLead()
      )
    )
    .subscribe({
      next: (res: any) => {
        // console.log(res);
      }
    });
    this.initData();
    this.initChart();
  }

  initData() {
    const { project_lead_name, project_lead_title, projectLeadName, projectLeadTitle } = this.project?.projectLead || this.project?.project_lead;
    this.projectLead.projectLeadName = project_lead_name ?? projectLeadName;
    this.projectLead.projectLeadTitle = project_lead_title ?? projectLeadTitle;
    this.projectLead.projectId = this.project.id;
    const { percentage_dtolist, percentageDTOList, tasks } = this.project;
    this.progressData = percentage_dtolist ?? percentageDTOList;
    this.tasks = tasks;

    this.tasks.forEach((t: any) => {
      t.priority = compareDate(t.due_date ?? t.dueDate);
    });
    this.remainingDay = getRemainingDaysByDate(this.project?.last_due_date || this.project?.lastDueDate);
  }

  initChart() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--p-text-color');

    this.chartData = {
      labels: [
        this.progressData[0]?.name,
        this.progressData[1]?.name,
        this.progressData[2]?.name,
      ],
      datasets: [
        {
          data: [
            this.progressData[0]?.total,
            this.progressData[1]?.total,
            this.progressData[2]?.total,
          ],
          backgroundColor: ['#D1D5DC', '#51A2FF', '#00D492'],
          hoverBackgroundColor: ['#D1D5DC', '#51A2FF', '#00D492'],
        },
      ],
    };

    this.options = {
      cutout: '60%',
      plugins: {
        legend: {
          display: false,
        },
      },
      responsive: false,
      maintainAspectRatio: false
    };
  }

  updateProjectLead() {
    return this.dashboardService.postProjectLead(this.projectLead);
  }

  inputLead() {
    this.lead$.next(this.projectLead);
  }

  avaLetter(target: string  | undefined) {
    if (!target) return '';
    return getFirstAndLastInitial(target);
  }

  getSortedDetailChecklist(list: any) {
    return list.sort((a: any, b: any) => (a.checked - b.checked));
  }

  getCheckListProgress(list: any) {
    let doneItem = 0;
    list.forEach((e: any) => {
      if (e.checked) {
        doneItem += 1;
      }
    })
    return doneItem;
  }
}
